
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getPageAPIs } from "@/common/util";
// import { CouponsManageAPI } from "@/common/api/couponList";
import AllInPayCashierFilingAPI from '@/common/api/merchantManage/allInPayCashierFiling';

import { DeepLoop } from "@/common/deepLoop/deepLoop";
import ZlSelect from "@/components/third-custom-components/select";

import ZlOption from "@/components/third-custom-components/option";

import {
  getCommonList,
  shareConfirmOptions
} from '@/common/config'

export const pageApiList = getPageAPIs(AllInPayCashierFilingAPI)

const defaultForm = {
  shop_name: '',
  shop_name_id: '',
  status: 0, // 状态 0全部 1审核中 2成功  3失败  
}

const defaultForms = {
  shop_id: '', // 
  province_code: '', // 省名code
  allin_number_id: '', // 商户号
  regeo_address: '', // 详细地址
  // singleMaxCountType: '0',
  // shop_id: "",
  // maxLimitCount: ''
};

const defaultTerminalSwitchForm = {
  brand_type: '',
  province_code: '',
  type: ''
}

const defaultCommonFilingForm = {
  brand_type: '',
  province_code: '',
  allin_number_id: ''
}

// 平台  1熊猫  2众享
const brandType2Ch: string[] = ['', '熊猫', '众享']


// 类型 1店铺终端号 2区域终端
const ternimalType2Ch: string[] = ['', '店铺终端号', '区域终端']

// const defaultSearchVenuePageOption = {
//   page: 1,
//   limit: 10,
//   isRearchBottom: false,
// };

const saleMachineDialogTitle2ch: any = {
  "new-cashier-filing": "新增收银台报备",
  "edit-cashier-filing": "编辑收银台报备",
};


// 状态 0全部 1审核中 2成功  3失败  
const filingStatus2Ch: string[] = ['', '审核中', '成功', '失败']


// 状态 0审核中  1报备成功  2报备失败
const showListFilingStatus2Ch: string[] = ['审核中', '报备成功', '报备失败']

// 最大有效期
// const maxExpiredDays = 9999;

// 最大时长 单位分钟
// const maxTimeDuration = 24 * 60;

const maxBenefitRate = 100

@Component({
  components: {
    ZlSelect,
    ZlOption,
  },
  filters: {
    showCashierFilingStatusName(status: number) {
      return showListFilingStatus2Ch[status] || '未知'
    }
  }
})
export default class AllInPayCashierFiling extends Vue {
  private form: any = {
    // saleMachineId: "",
    // shop_name: "",
    // shop_id: '',
    // machine_number: '',
    // time: [],
    // startDate: "",
    // endDate: "",
  };
  private forms: any = {
    // maxType: "0",
    // ...defaultForms
  };

  private terminalSwitchForm: any = {

  }


  private commonFilingForm: any = {}

  private cashiderStatusList: any[] = [
    ...getCommonList(filingStatus2Ch, 1)
  ]

  private chooseBrandTypeList: any[] = [
    ...getCommonList(brandType2Ch, 1)
  ]

  private deepLoopUtil: any = {};

  // private merchantApi: any;

  private allInPayCashierFilingApi = new AllInPayCashierFilingAPI();

  // private saleMachineTimeDurationAPI = new AllInPayCashierFilingTimeDurationManageAPI();
  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    }

    this.terminalSwitchForm = {
      ...this.deepLoopUtil.deepCopy(defaultTerminalSwitchForm, false),
    }

    this.commonFilingForm = {
      ...this.deepLoopUtil.deepCopy(defaultCommonFilingForm, false),
    }

    // this.searchVenuePageOption = {
    //   ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
    // };

    // this.merchantApi = new MerchantApi();
  }

  // private chooseProviceList: any[] = []

  // private refreshProviceList() {
  //   return new Promise((resolve, reject) => {
  //     this.allInPayCashierFilingApi.getFilingProviceList({}, (res: any) => {
  //       const {
  //         list = []
  //       } = res.data || {}

  //       this.chooseProviceList = list

  //       resolve(list)
  //     }, (err: any) => {
  //       reject(err)
  //     })
  //   })
  // }

  // private onChangeFilingProvice() {
  //   this.refreshCityList()
  // }

  // private chooseCityList: any[] = []
  // private refreshCityList(provinceItem: any = null) {
  //   const forms = this.forms


  //   provinceItem = provinceItem || forms.provinceItem || {}

  //   const {
  //     code = ''
  //   } = provinceItem || {}
  //   return new Promise((resolve, reject) => {
  //     if (!code) {
  //       this.chooseCityList = []
  //       resolve([])
  //       return 
  //     }
  //     this.allInPayCashierFilingApi.getFilingCityOrAreaList({
  //       city_id: code
  //     }, (res: any) => {
  //       const {
  //         list = []
  //       } = res.data || {}

  //       this.chooseCityList = list

  //       resolve(list)
  //     }, (err: any) => {
  //       this.chooseCityList = []
  //       reject(err)
  //     })
  //   })
  // }

  // private onChangeFilingCity() {
  //   this.refreshAreaList() 
  // }

  // private chooseAreaList: any[] = []
  // private refreshAreaList(cityItem: any = null) {
  //   const forms = this.forms

  //   cityItem = cityItem || forms.cityItem || {}

  //   const {
  //     code = ''
  //   } = cityItem || {}
  //   return new Promise((resolve, reject) => {
  //     if (!code) {
  //       this.chooseAreaList = []
  //       resolve([])
  //       return 
  //     }
  //     this.allInPayCashierFilingApi.getFilingCityOrAreaList({
  //       city_id: code
  //     }, (res: any) => {
  //       const {
  //         list = []
  //       } = res.data || {}

  //       this.chooseAreaList = list

  //       resolve(list)
  //     }, (err: any) => {
  //       this.chooseAreaList = []
  //       reject(err)
  //     })
  //   })
  // }

  
  private created(): void {
    this.getAllInPayCashierFilings();

    // this.refreshAllInPayCashierFilingTimeDurations();

    // this.refreshTableClass();
  }
  private restForm(): void {
    this.form = new Util().clearObject(this.form);

    this.getAllInPayCashierFilings();
  }
  //搜索
  private search(): void {
    this.tablePage.page = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getAllInPayCashierFilings();
  }

  private tableData: any[] = [];

  //dialog
  // private dialogFormVisible: boolean = false;
  private formLabelWidth: string = "70px";
  
  private tablePage: any = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };
  // //翻页
  private handlePageChange(val: any) {
    this.tablePage.page = val.currentPage;
    this.tablePage.prepage = val.pageSize;
    this.getAllInPayCashierFilings();
  }

  private addOrUpdateAllInPayCashierFilingTitle: string = "收银台报备";

  private dialogFormVisible: boolean = false;

  // 拉起收银台报备弹框
  private handleWakeAllInPayCashierFilingDialog(mode: string) {
    // if (mode == 'new-cashier-filing') { // 新增收银台报备

    // }
    this.allInPayCashierFilingMode = mode;
    this.addOrUpdateAllInPayCashierFilingTitle = saleMachineDialogTitle2ch[mode] || "收银台报备";
    
    this.chooseProviceList = []

    this.chooseAllinNumberIdList = []

    this.initAllInPayCashierFilingForm(mode);

    this.dialogFormVisible = true;
  }

  private currentAllInPayCashierFilingItem: any = null;

  private allInPayCashierFilingMode: string = "";

  private async initAllInPayCashierFilingForm(mode: string) {
    const forms: any = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    this.curCheckCasiherShopInfo = {
      brand_type: ''
    }

    // this.chooseProviceList = []
    // this.chooseCityList = []
    // this.chooseAreaList = []

    // await this.refreshProviceList();

    if (mode == "edit-cashier-filing") {
      // 编辑

      // await this.refreshAllInPayCashierFilingTimeDurations();

      // await this.refreshTableClass();

      this.forms = forms

      const currentAllInPayCashierFilingItem = this.currentAllInPayCashierFilingItem;

      const {
        id,
        shop_id,
        province_code,

        allin_number_id,
        
        address = '',
        brand_type
      } = await (this.refreshEditAllinPayCashierFilingInfo(currentAllInPayCashierFilingItem.id) || {}) as any;

      

      if (shop_id) {
        forms.shop_id = shop_id;
      }

      if (province_code) {
        forms.province_code = province_code
      }

      if (allin_number_id) {
        forms.allin_number_id = allin_number_id
      }

      if (address) {
        forms.regeo_address = address
      }

      Object.assign(this.curCheckCasiherShopInfo, {
        brand_type
      })

      // const chooseProvinceList = this.chooseProviceList

      // this.refreshProvinceAndCityAndAreaForm(forms, chooseProvinceList, {
      //   province,
      //   city,
      //   area
      // })

      

     


      // if (shop_name && typeof shop_id == "number") {
      //   console.log(shop_id, "shop_id");

      //   console.log(this.venueList, "this.venueList");
      //   let existVenue = this.venueList.find((venue) => venue.id == shop_id);

      //   if (!existVenue) {
      //     existVenue = {
      //       id: shop_id,
      //       name: shop_name,
      //     };
      //     this.venueList.push(existVenue);
      //   }

      //   forms.venue = existVenue;
      // }

      forms.id = id;
    }

    console.log(forms, "forms");

    // console.log(this.venueList, "this.venueList");

    this.forms = forms;
  }

  // private async refreshProvinceAndCityAndAreaForm(forms: any, provinceList: any[], {
  //   province = '',
  //   city = '',
  //   area = ''
  // }: any) {
  //   if (province) {
  //     const choseProvinceItem = provinceList.find((provinceItem: any) => provinceItem.name == province) || {}

  //     forms.provinceItem = choseProvinceItem

  //     if (choseProvinceItem.code) {
  //       await this.refreshCityList(choseProvinceItem)

  //       const chooseCityList = this.chooseCityList

  //       const chooseCityItem = chooseCityList.find((cityItem: any) => cityItem.name == city) || {}

  //       forms.cityItem = chooseCityItem

  //       if (chooseCityItem.code) {
  //         await this.refreshAreaList(chooseCityItem)

  //         const chooseAreaList = this.chooseAreaList

  //         const chooseAreaItem = chooseAreaList.find((areaItem: any) => areaItem.name == area) || {}

  //         forms.areaItem = chooseAreaItem
  //       }
  //     }
  //   }
  // }

  private curCheckCasiherShopInfo: any = {
    brand_type: ''
  }

  private refreshCashierShopInfoTimer: any

  private onRefreshCashierShopInfo(val: any) {
    clearTimeout(this.refreshCashierShopInfoTimer)

    if (!val) {
      if (this.dialogFormVisible) {
        this.chooseProviceList = []
      }
      return
    }

    this.refreshCashierShopInfoTimer = setTimeout(() => {
      this.onCheckCashierShopInfo()
    }, 400)
  }

  private onCheckCashierShopInfo() {
    const forms = this.forms

    const {
      shop_id
    } = forms || {}

    if (!shop_id) {
      this.$message.error('请输入店铺ID')
      return 
    }

    this.allInPayCashierFilingApi.getSimpleCashierShopInfo({
      shop_id
    }, (res: any) => {
      const {
        data
      } = res

      Object.assign(this.curCheckCasiherShopInfo, {
        ...(data || {})
      })
    }, (err: any) => {
      console.log(err, 'err')
    })
  }

  private refreshEditAllinPayCashierFilingInfo(filingId: number) {
    return new Promise((resolve, reject) => {
      this.allInPayCashierFilingApi.getFilingCashierInfo({
        id: filingId
      }, (res: any) => {
        const {
          item = {} 
        } = res.data || {}

        resolve(item || {})
      }, (err: any) => {
        reject(err)
      })
    })
  }

  private chooseProviceList: any[] = []

  @Watch('curCheckCasiherShopInfo.brand_type')
  private refreshPlatformProvinceList(val: any) {
    if (!val) return

    console.log(val, 'val')

    this.allInPayCashierFilingApi.getPlatformProvinceList({
      brand_type: val
    }, (res: any) => {

      const {
        lists = []
      } = res.data || {}

      if (Array.isArray(lists)) {
        this.chooseProviceList = lists
      } else {
        this.chooseProviceList = []
      }

    }, (err: any) => {
      console.log(err, 'err')
    })
  }

  private chooseAllinNumberIdList: any[] = []

  @Watch('forms.province_code')
  private refreshPlatformProvinceMerchantList(val: any) {
    if (!val) return

    const curCheckCasiherShopInfo = this.curCheckCasiherShopInfo

    const {
      brand_type
    } = curCheckCasiherShopInfo || {}

    if (!brand_type) return 

    this.allInPayCashierFilingApi.getPlatformProvinceMerchantList({
      brand_type,
      province_code: val
    }, (res: any) => {

      const {
        lists = []
      } = res.data || {}

      if (Array.isArray(lists)) {
        this.chooseAllinNumberIdList = lists
      } else {
        this.chooseAllinNumberIdList = []
      }

    }, (err: any) => {
      console.log(err, 'err')
    })
  }

  private handleWakeEditAllInPayCashierFilingDialog(saleMachineItem: any) {
    this.currentAllInPayCashierFilingItem = saleMachineItem;

    this.handleWakeAllInPayCashierFilingDialog("edit-cashier-filing");
  }


  private onSyncCashierFiling(cashierFilingItem: any) {
    const set = Util.setListProp;

    set(
      this,
      this.tableData,
      cashierFilingItem,
      "__syncCashierFilingLoading",
      true
    );

    this.allInPayCashierFilingApi.syncCashierFiling({
      id: cashierFilingItem.id
    }, (res: any) => {
      set(
        this,
        this.tableData,
        cashierFilingItem,
        "__syncCashierFilingLoading",
        false
      );


    }, (err: any) => {
      set(
        this,
        this.tableData,
        cashierFilingItem,
        "__syncCashierFilingLoading",
        false
      );
    })
  }

  private dialogTerminalSwitchVisible: boolean = false

  private sumbitTerminalSwitchLoading: boolean = false

  private chooseTerminalTypeList: any[] = [
    ...getCommonList(ternimalType2Ch, 1)
  ]

  private chooseTerminalSwitchProvinceList: any[] = []


  private onRefreshTerminalSwitchProvinceList() {
    const terminalSwitchForm = this.terminalSwitchForm

    const {
      brand_type
    } = terminalSwitchForm || {}

    if (!brand_type) return

    this.allInPayCashierFilingApi.getPlatformProvinceList({
      brand_type
    }, (res: any) => {

      const {
        lists = []
      } = res.data || {}

      if (Array.isArray(lists)) {
        this.chooseTerminalSwitchProvinceList = lists
      } else {
        this.chooseTerminalSwitchProvinceList = []
      }

    }, (err: any) => {
      console.log(err, 'err')
    })
  }

  private onWakeTerminalSwitchDialog() {
    this.terminalSwitchForm = {
      ...this.deepLoopUtil.deepCopy(defaultTerminalSwitchForm, false),
    }

    this.dialogTerminalSwitchVisible = true
  }


  private handleSumbitFilingTerminalSwitch() {
    const terminalSwitchForm = this.terminalSwitchForm

    const {
      brand_type,
      province_code,
      type,
    } = terminalSwitchForm || {}

    if (!brand_type) {
      this.$message.error('请选择平台')
      return
    }

    if (!province_code) {
      this.$message.error('请选择省份')
      return
    }

    if (!type) {
      this.$message.error('请选择终端类型')
      return
    }

    this.sumbitCommonFilingLoading = true

    this.allInPayCashierFilingApi.switchFilingTerminal(terminalSwitchForm, (res: any) => {
      this.$message.success('切换成功')

      this.sumbitCommonFilingLoading = false

      this.dialogTerminalSwitchVisible = false
    }, (err: any) => {
      console.log(err, 'err')

      this.sumbitCommonFilingLoading = false
    })

  }


  private dialogCommonFilingVisible: boolean = false

  private onWakeCommonFilingDialog() {
    this.commonFilingForm = {
      ...this.deepLoopUtil.deepCopy(defaultCommonFilingForm, false),
    }

    this.dialogCommonFilingVisible = true
  }

  private sumbitCommonFilingLoading: boolean = false

  private chooseCommonFilingProvinceList: any[] = []

  private onRefreshCommonFilingProvinceList() {
    const commonFilingForm = this.commonFilingForm

    const {
      brand_type
    } = commonFilingForm || {}

    if (!brand_type) return

     this.allInPayCashierFilingApi.getPlatformProvinceList({
      brand_type
    }, (res: any) => {

      const {
        lists = []
      } = res.data || {}

      if (Array.isArray(lists)) {
        this.chooseCommonFilingProvinceList = lists
      } else {
        this.chooseCommonFilingProvinceList = []
      }

    }, (err: any) => {
      console.log(err, 'err')
    })
  }

  private chooseCommonFilingMerchantList: any[] = []

  private onRefreshCommonFilingMerchantList() {
    const commonFilingForm = this.commonFilingForm

    const {
      brand_type,
      province_code
    } = commonFilingForm || {}

    if (!brand_type || !province_code) return

    this.allInPayCashierFilingApi.getPlatformProvinceMerchantList({
      brand_type,
      province_code,
    }, (res: any) => {

      const {
        lists = []
      } = res.data || {}

      if (Array.isArray(lists)) {
        this.chooseCommonFilingMerchantList = lists
      } else {
        this.chooseCommonFilingMerchantList = []
      }

    }, (err: any) => {
      console.log(err, 'err')
    })
  }

  private handleSumbitCommonFiling() {
    const commonFilingForm = this.commonFilingForm

    const {
      brand_type,
      province_code,
      allin_number_id,
    } = commonFilingForm || {}

    if (!brand_type) {
      this.$message.error('请选择平台')
      return
    }

    if (!province_code) {
      this.$message.error('请选择省份')
      return
    }

    if (!allin_number_id) {
      this.$message.error('请选择商户号')
      return
    }

    this.dialogCommonFilingVisible = false

    const api = this.allCommonFiling.bind(this, commonFilingForm)
    this.handleWakeLoopWQueryDialog(api)

  }

  private allCommonFiling(params: any) {
    return new Promise((resolve, reject) => {
      this.allInPayCashierFilingApi.allCashierFilingTerm({
        ...params
      }, (res: any) => {
        const {
          total
        } = res.data || {}

        resolve(total)

      }, (err: any) => {
        reject(err)
      })
    })
  }



  private onSyncAllTerminalFiling() {
    const api = this.allFilingChecksyncQuery.bind(this)
    this.handleWakeLoopWQueryDialog(api)
  }

  private allFilingChecksyncQuery() {
    return new Promise((resolve, reject) => {
      this.allInPayCashierFilingApi.allFilingCheckSyncQuery({}, (res: any) => {
        const {
          total
        } = res.data || {}

        resolve(total)

      }, (err: any) => {
        reject(err)
      })
    })
  }


  // 全局轮询弹框

  private dialogLoopQueryVisible: boolean = false

  private progressCount: number = 0

  private handleWakeLoopWQueryDialog(api: Function) {
    console.log(api, 'api')

    console.log(typeof api, 'typeof api')
    if (typeof api !== 'function') return
    
    this.progressCount = 0

    const action: any = () => {
      api().then((total: number) => {
        console.log(total, 'total')
        if (total > 0) {
          this.progressCount += total

          action()
        } else {
          this.dialogLoopQueryVisible = false
        }
      })
    }

    this.dialogLoopQueryVisible = true

    action()
  }





  // private handleDelteAllInPayCashierFilingDialog(saleMachineItem: any) {
  //   this.$confirm("确定删除该收银台报备?", "", {
  //     ...shareConfirmOptions,
  //   }).then(() => {
  //     this.allInPayCashierFilingApi.deleteAllInPayCashierFiling({
  //       id: saleMachineItem.id
  //     }, () => {
  //       this.getAllInPayCashierFilings()
  //     }, () => {

  //     })
  //   });
  // }

  // private venueList: any[] = [
  //   // {
  //   //   id: 1,
  //   //   label: '测试'
  //   // },
  //   // {
  //   //   id: 2,
  //   //   label: '测试2'
  //   // }
  // ];

  // private searchVenueLoading: boolean = false;

  // private remoteGetVenueQueryString: string = "";

  // private remoteSearchVenueTimer: any = null;

  // private searchVenuePageOption: any = {};

  // private initRemoteGetVenuePageOption() {
  //   this.searchVenuePageOption = {
  //     ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
  //   };
  // }

  // private getSearchVenueParams() {
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const remoteGetVenueQueryString = this.remoteGetVenueQueryString;

  //   const { page, limit } = searchVenuePageOption;

  //   const params: any = {
  //     page,
  //     limit,
  //   };

  //   if (remoteGetVenueQueryString && remoteGetVenueQueryString.trim()) {
  //     params.name = remoteGetVenueQueryString.trim();
  //   }

  //   return params;
  // }

  // private getMoreVenueList(refresh: boolean = true) {
  //   return new Promise((resolve: Function, reject: Function) => {
  //     if (refresh) {
  //       this.initRemoteGetVenuePageOption();
  //     }

  //     const params = this.getSearchVenueParams();

  //     this.allInPayCashierFilingApi.searchVenueList(
  //       params,
  //       (res: any) => {
  //         console.log(res, "res");

  //         const venueList: any[] = res.data || [];

  //         this.venueList = refresh
  //           ? venueList
  //           : this.venueList.concat(venueList);

  //         if (Array.isArray(res.data) && res.data.length == 0) {
  //           this.searchVenuePageOption.isRearchBottom = true;
  //         }
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         resolve();
  //       },
  //       () => {
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         reject();
  //       }
  //     );
  //   });
  // }

  // // 第一次搜索 无关键字
  // private handleFirstGetVenueList() {
  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 清空搜索
  // private handleClearGetVenueList() {
  //   this.remoteGetVenueQueryString = "";

  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 远程搜索
  // private remoteGetVenueMethod(query: string) {
  //   query = query.trim ? query.trim() : "";

  //   if (query !== "") {
  //     this.remoteGetVenueQueryString = query;
  //     clearTimeout(this.remoteSearchVenueTimer);

  //     this.remoteSearchVenueTimer = setTimeout(() => {
  //       this.searchVenueLoading = true;

  //       this.getMoreVenueList();
        
  //     }, 300);
  //   } else {
  //     this.remoteGetVenueQueryString = "";
  //     this.venueList = [];
  //   }
  // }

  // private addVenueListLoading: boolean = false;

  // private remoteAddVenueMethod() {
  //   if (this.addVenueListLoading) return;
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const { isRearchBottom } = searchVenuePageOption;

  //   if (isRearchBottom) return;

  //   this.searchVenuePageOption.page++;

  //   this.addVenueListLoading = true;

  //   this.getMoreVenueList(false);
  // }

  // 分成比例
  // private handleLimitBenefitRate(val: string) {
  //   Util.limitIntegetInput(
  //     val,
  //     (new_val: string) => {
  //       const limit_val = Math.min(Number(new_val), maxBenefitRate).toString();
  //       this.$set(this.forms, "fencheng_rate", limit_val);
  //     },
  //     (new_val: string) => {
  //       this.$set(this.forms, "fencheng_rate", new_val);
  //     }
  //   );
  // }

  // private handleLimitSingleMaxCount(val: string) {
  //   Util.limitIntegetInput(
  //     val,
  //     (new_val: string) => {
  //       this.$set(this.forms, "maxLimitCount", new_val);
  //     },
  //     (new_val: string) => {
  //       this.$set(this.forms, "maxLimitCount", new_val);
  //     }
  //   );
  // }

  private sumbitAllInPayCashierFilingLoading: boolean = false;

  // 提交收银台报备配置
  private handleSumbitAllInPayCashierFiling() {
    const allInPayCashierFilingMode = this.allInPayCashierFilingMode;

    const params = this.getAllInPayCashierFilingFormsParams(allInPayCashierFilingMode);

    console.log(params, "params");
    if (params === false) return;

    this.sumbitAllInPayCashierFilingLoading = true;
    switch (allInPayCashierFilingMode) {
      case "new-cashier-filing":
        this.allInPayCashierFilingApi.addAllInPayCashierFiling(
          params,
          () => {
            this.getAllInPayCashierFilings();
            this.dialogFormVisible = false;
            this.sumbitAllInPayCashierFilingLoading = false;
          },
          () => {
            this.sumbitAllInPayCashierFilingLoading = false;
          }
        );
        break;
      case "edit-cashier-filing":
        this.allInPayCashierFilingApi.updateAllInPayCashierFiling(
          params,
          () => {
            this.getAllInPayCashierFilings();
            this.dialogFormVisible = false;
            this.sumbitAllInPayCashierFilingLoading = false;
          },
          () => {
            this.sumbitAllInPayCashierFilingLoading = false;
          }
        );
        break;
    }
  }

  private getAllInPayCashierFilingFormsParams(mode: string) {
    const params: any = {};

    const showErrorMessage = (msg: string) => {
      if (!!msg) {
        this.$message.error(msg);
      }
    };

    const forms = this.forms;

    const {
      id,
      // name,
      // expired_days,
      // meituanId,
      // timeDuration
      // machine_number,
      shop_id,
      regeo_address,
    
      // fencheng_rate,
      // venue,
    } = forms || {};

    if (mode == "new-cashier-filing") {
      Object.assign(params, {
        shop_id
      })
    }

    
    

    // if (venue && venue.id) {
    //   params.shop_id = venue.id;
    // } else {
    //   showErrorMessage("请选择一个店铺");
    //   return false;
    // }

    const keys = ["province_code", "allin_number_id"];

    const key2EndKey: any = {
      province_code: "province_code",
      allin_number_id: "allin_number_id"
    };

    const key2ErrMsg: any = {
      province_code: "省份不能为空",
      allin_number_id: "商户号不能为空"
    };

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      if (forms[key]) {
        const errMsg = key2ErrMsg[`${key}_${forms[key]}`];
        if (errMsg) {
          showErrorMessage(errMsg);

          return false;
        }
        params[key2EndKey[key] || key] = forms[key];
      } else {
        showErrorMessage(key2ErrMsg[key]);

        return false;
      }
    }


    

    if (mode == "edit-cashier-filing") {
      params.id = id;

      if (regeo_address) {
        params.regeo_address = regeo_address
      } else {
        showErrorMessage('详情地址不能为空');

        return false;
      }
    }

    return params;

  }

  //获取收银台报备列表
  private getAllInPayCashierFilings(): void {
    this.allInPayCashierFilingApi.getAllInPayCashierFilingList(
      { ...this.getAllInPayCashierFilingParams() },
      (res: any) => {
        // res.data.list
        this.tableData = res.data.list;
        this.tablePage.page = res.data.page;
        this.tablePage.prepage = res.data.prepage;
        // this.tablePage.totalPage = res.data.total;
        this.tablePage.count = res.data.count;
      },
      () => {}
    );
  }

  private getAllInPayCashierFilingParams(): any {

    const form = this.form;

    const tablePage = this.tablePage;

    const { page, prepage } = tablePage;

    const { shop_name, shop_name_id, status } = form;

    const params: any = {
      status
    };

    if (shop_name) {
      params.shop_name = shop_name;
    }

    if (shop_name_id) {
      params.shop_name_id = shop_name_id
    }



    if (page) {
      params.page = page;
    }

    if (prepage) {
      params.limit = prepage;
    }

    return params;
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }

  private selectPage: any = {
    page: 1,
    prepage: 200,
    totalPage: 0,
    count: 0,
  };
}
